import Vue from 'vue'
import App from './App.vue'
import store from './store';
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import 'font-awesome/css/font-awesome.min.css';
import PageHeader from '@/components/PageHeader/PageHeader.vue'
import pleaseWaiting from '@/utils/please-waiting.js'
import utils from '@/utils/tools.js'
import moment from "moment";
import Empty from '@/components/Empty.vue'

Vue.component('page-header', PageHeader)
Vue.component('list-empty', Empty)


Vue.prototype.$waiting = pleaseWaiting;

Vue.prototype.$utils = utils;
Vue.prototype.$moment = moment;

Vue.config.productionTip = false

Vue.use(ElementUI)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
